import { NgModule } from '@angular/core';
import { SpinDirective } from './spin.directive';

@NgModule({
    declarations: [
        SpinDirective
    ],
    imports: [],
    exports: [
        SpinDirective
    ]
})
export class NcSpinModule { }